
import { updateObject } from 'utils/helpers/updateObject';
import { actionTypes, GetModulesFailureAction, GetModulesRequestAction, GetModulesSuccessAction, ModulesAction, stateStatusType, } from './actionType';
import {  ModulesState, initialState } from './state';

// getModulesRequest
const getModulesRequest = (state: ModulesState, action: GetModulesRequestAction) => {
    return updateObject(
        state, {
        getModulesState: {
            ...state.getModulesState,
            isLoading: true,
            error: null,
            status: null
        }
    });
};

const getModulesSuccess = (state: ModulesState, action: GetModulesSuccessAction) => {
    return updateObject(state, {
        getModulesState: {
            ...state.getModulesState,
            isLoading: false,
            error: null,
            status: stateStatusType.SUCCESS,
            modules: action.payload
        }
    });
};

const getModulesFail = (state: ModulesState, action: GetModulesFailureAction) => {
    return updateObject(state, {
        getModulesState: {
            ...state.getModulesState,
            isLoading: false,
            error: action.payload,
            status: stateStatusType.FAILED,
            modules: null
        }
    });
};
const getModulesReducer = (state = initialState, action: ModulesAction) => {
    switch (action.type) {
        case actionTypes.GET_MODULES_REQUEST:
            return getModulesRequest(state, action);
        case actionTypes.GET_MODULES_SUCCESS:
            return getModulesSuccess(state, action);
        case actionTypes.GET_MODULES_FAIL:
            return getModulesFail(state, action);
        default:
            return state;
    }
};

export default getModulesReducer;

